import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Divider,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import CardLayout from "../../layouts/CardLayout";
import { useNavigate, useParams } from "react-router-dom";
import errorHandler from "../../utils/errorHandler";
import contestmanagerapi from "../../services/contestmanager";
import { capitalize, capitalizeText } from "../../utils/helpers";

const ViewContestmanager = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  const [contestview, setcontestview] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await contestmanagerapi.getById({ id });
        setcontestview(response.data.data);
      } catch (error) {
        errorHandler(error);
      }
    };

    fetchData();
  }, [id]);

  const handleEdit = () => {
    navigate(`/contest/edit/${id}`);
  };

  console.log("contestview", contestview);
  return (
    <div>
      <Box sx={{ p: 3 }}>
        <Helmet>
          <title>View Contest Manager</title>
        </Helmet>
        <CardLayout>
          <Card
            sx={{
              borderRadius: 3,
              backgroundColor: "#fdfcff",
              boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.04)",
              px: 3,
              py: 2,
            }}
          >
            <CardHeader
              title="View Contest Manager"
              titleTypographyProps={{
                sx: { fontWeight: 600, fontSize: "1.25rem", color: "#2f2f4f" },
              }}
              action={
                <Stack direction="row" spacing={1}>
                  <Button
                    variant="outlined"
                    sx={{
                      borderColor: "#bb86fc",
                      color: "#7c4dff",
                      boxShadow: "0 0 0 2px #f3e8ff",
                      "&:hover": {
                        backgroundColor: "#f3e8ff",
                      },
                    }}
                    onClick={() => navigate("/contest")}
                  >
                    Back
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      background: "linear-gradient(90deg, #7c4dff, #a95eff)",
                      color: "#fff",
                      boxShadow: "0 4px 12px rgba(124, 77, 255, 0.3)",
                      "&:hover": {
                        background: "#7c4dff",
                      },
                    }}
                    onClick={handleEdit}
                  >
                    Edit
                  </Button>
                </Stack>
              }
            />
            <Divider sx={{ my: 2 }} />
            <CardContent>
              <Grid container spacing={4}>
                <Grid item xs={12} md={3}>
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    gutterBottom
                  >
                    Name
                  </Typography>
                  <Typography variant="body2">
                    {capitalize(contestview?.name || "-")}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    gutterBottom
                  >
                    Contest Type
                  </Typography>
                  <Typography variant="body2">
                    {contestview?.contest_type}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    gutterBottom
                  >
                    Per User Entry
                  </Typography>
                  <Typography variant="body2">
                    {contestview?.per_user_entry}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    gutterBottom
                  >
                    Entry Fee
                  </Typography>
                  <Typography variant="body2">
                    {contestview?.entry_fee
                      ? Math.floor(contestview?.entry_fee)
                      : "NA"}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    gutterBottom
                  >
                    Prize Pool
                  </Typography>
                  <Typography variant="body2">
                    {contestview?.prize_pool}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    gutterBottom
                  >
                    Total Spots
                  </Typography>
                  <Typography variant="body2">
                    {contestview?.total_spots}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    gutterBottom
                  >
                    Filled Spots
                  </Typography>
                  <Typography variant="body2">
                    {contestview?.filled_spots}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    gutterBottom
                  >
                    Status
                  </Typography>
                  <Chip
                    label={contestview?.status}
                    sx={{
                      color:
                        contestview?.status === "ongoing" || "completed"
                          ? "success.main"
                          : "error.main",
                      borderColor:
                        contestview?.status === "ongoing" || "completed"
                          ? "success.main"
                          : "error.main",
                      backgroundColor: "transparent",
                      fontWeight: 500,
                      px: 2,
                      py: 0.5,
                      fontSize: "0.875rem",
                    }}
                    variant="outlined"
                  />
                </Grid>
                {contestview?.winnings && contestview.winnings.length > 0 && (
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle1"
                      color="text.secondary"
                      gutterBottom
                    >
                      Winnings
                    </Typography>
                    <Grid container spacing={2}>
                      {contestview.winnings.map((win, index) => (
                        <Grid item xs={12} md={3} key={index}>
                          <Typography variant="subtitle2" gutterBottom>
                            Rank {win.to} - {win.from}
                          </Typography>
                          <Typography variant="body2">
                            Prize: {win.price}
                          </Typography>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                )}

                {contestview?.rules &&
                  Object.keys(contestview.rules).length > 0 && (
                    <Grid item xs={12}>
                      <Typography
                        variant="subtitle1"
                        color="text.secondary"
                        gutterBottom
                      >
                        Rules
                      </Typography>
                      <Grid container spacing={2}>
                        {Object.entries(contestview.rules).map(
                          ([position, amount], index) => (
                            <Grid item xs={12} md={3} key={index}>
                              <Typography variant="subtitle2" gutterBottom>
                                Position {position}
                              </Typography>
                              <Typography variant="body2">₹{amount}</Typography>
                            </Grid>
                          )
                        )}
                      </Grid>
                    </Grid>
                  )}
              </Grid>
            </CardContent>
          </Card>
        </CardLayout>
      </Box>
    </div>
  );
};

export default ViewContestmanager;
